$('span#mnav_shop').click(function(){
  window.location = '/collections';
});

document.querySelector('a.header-actions__action.action__cart').addEventListener('click', (event) => {
  event.preventDefault();
});

window.awp_update_options = setInterval(function(){
  const $rebsmc = $('[data-smartcart-items]');
  if ($rebsmc.children().length === 1 && $rebsmc.find('.product-climate-positive-order').length) {
    Rebuy.Cart.clearCart()
  }
}, 500);

const aa_planid = $("#rtx_option_plans_dropdown option:contains(4 weeks)").attr(
  "value"
);

if (aa_planid) {
  $('.product-form.products-subscription input[name="selling_plan"]').val(
    aa_planid
  );
}

$(function() {
  $('.aa_video-tag video .showImg').attr('aria-hidden', 'true');
});

(function($){
  $(function(){
    // ensure first option is selected for rtx dropdown
    function ensureFirstOption() {
      var $s = $('#rtx_option_plans_dropdown');
      if ($s.length && $s.prop('selectedIndex') < 0 && $s.find('option').length) {
        $s.prop('selectedIndex', 0).trigger('change');
      }
    }

    // run on ready and poll briefly for dynamically-inserted selects
    ensureFirstOption();
    var tries = 0;
    var poll = setInterval(function(){
      ensureFirstOption();
      if (++tries > 10) clearInterval(poll);
    }, 300);

    // on Add-to-cart click for subscription (handles both 'suscription-cart' typo and 'subscription-cart')
    $(document).on('click', '.add-to-cart.suscription-cart, .add-to-cart.subscription-cart', function(){
      ensureFirstOption(); // ensure selection before submission
      setTimeout(function(){
        if (window.Rebuy && Rebuy.Cart && typeof Rebuy.Cart.fetchCart === 'function') {
          Rebuy.Cart.fetchCart();
          if (Rebuy.SmartCart && typeof Rebuy.SmartCart.show === 'function') {
            Rebuy.SmartCart.show();
          }
        }
      }, 700);
    });
  });
})(jQuery);

function aa_bodyobserver() {
  let labelinserted = false;
  let ariainserted = false;

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1 && node.querySelector('#countrySelect') && !labelinserted) {
          setTimeout(() => {
            $('#countrySelect').after('<label for="countrySelect" class="hide">Select Your Country</label>');
          }, 100);
          
          labelinserted = true;
        }

        if (node.nodeType === 1 && node.querySelector('.zest--width-full input') && !ariainserted) {
          node.querySelector('.zest--width-full input').setAttribute('aria-label', 'zest-button-input');
          
          ariainserted = true;
        }
        

        if (node.nodeType === 1 && node.querySelector('#junipOutlineStar')) {
          $('#junipStarSymbols, #junipStarSymbols svg').attr('aria-hidden', 'true');
        }
        
        if (node.nodeType === 1 && node.querySelector('.rebuy-carousel__arrows svg')) {
          $('.rebuy-cart__progress-step-icon svg').attr('aria-hidden', true)
          $('.rebuy-carousel__arrows svg').attr('aria-label', 'carousel arrow');
        }

        if (node.nodeType === 1 && node.querySelector('.junip-product-summary-stars-wrapper svg[role="img"]')) {
          $('.junip-stars-container svg[role="img"]').attr('aria-label', 'Rating Star')
        }

        $('i.snptico, i[class*="snptico-"]').attr('aria-hidden', 'true').attr('role', 'presentation');

        $('.pd-modal__content .pd-modal__close').attr('aria-label', 'Modal Close');
        $('.pd-modal__content .pd-modal__close svg').attr('aria-label', 'Modal Close icon');
        
        if ($('.pd-modal__content .pd-modal__title').is(':empty') && !$('body').hasClass('template-product')) {
          $('.pd-modal__content .pd-modal__title').append('<span class="hide">Modal Heading</span>');
          $('.pd-modal__content .pd-modal__close').append('<span class="hide">Close Button</span>');
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

aa_bodyobserver();





// $('body').on('DOMNodeInserted', function(e) {
//   if (e.originalEvent.relatedNode.localName == 'zest-button' && e.target.localName == "input") {
//     e.target.setAttribute('aria-label', 'zest-button-input');
//   }

//   if (e.target.id == "zonos") {
//     setTimeout(function() {
//       $('#zonos #countrySelect').before('<label for="countrySelect" class="hide">Select Your Country</label>');
//     }, 500);
//   }
// });

// function waitForElement(selector, callback) {
//     const observer = new MutationObserver((mutations, observer) => {
//         const element = document.querySelector(selector);
//         if (element) {
//             observer.disconnect();
//             callback(element);
//         }
//     });

//     observer.observe(document.body, {
//         childList: true,
//         subtree: true,
//     });
// }

// waitForElement('body', (element) => {
//   if(element.querySelector('.zest--width-full').hasChildNodes()) {
//     console.log('okkkkkk')
//     element.querySelector('.zest--width-full input').setAttribute('aria-label', 'zest-button-input');
//   }
// });

// waitForElement('.zest--width-full', (element) => {
//   element.querySelector('input').setAttribute('aria-label', 'zest-button-input');
// });

// waitForElement('#zonos #countrySelect', (element) => {
//   element.insertAdjacentHTML('afterend', '<label for="countrySelect" class="hide aarif">Select Your Country</label>');
// });







/**
 * Lightweight Klaviyo Review Count Formatter
 * Minimal resource usage - only runs when needed
 */
(function() {
  'use strict';
  
  let isProcessing = false;
  let processedCount = 0;
  
  // Lightweight function to update review counts
  function updateReviewCount() {
    if (isProcessing) return;
    isProcessing = true;
    
    const reviewLabels = document.querySelectorAll('.kl_reviews__star_rating_widget__label:not([data-formatted])');
    
    reviewLabels.forEach(function(label) {
      const text = label.textContent.trim();
      const match = text.match(/(\d+)\s+reviews?/i);
      
      if (match) {
        label.textContent = '(' + match[1] + ')';
        label.setAttribute('data-formatted', '1');
        processedCount++;
      }
    });
    
    isProcessing = false;
    return reviewLabels.length;
  }
  
  // Single observer with efficient filtering
  function startObserver() {
    const observer = new MutationObserver(function(mutations) {
      let hasKlaviyoChanges = false;
      
      for (let mutation of mutations) {
        if (mutation.type === 'childList') {
          for (let node of mutation.addedNodes) {
            if (node.nodeType === 1 && // Element node
                (node.className && node.className.includes('kl_reviews') ||
                 node.querySelector && node.querySelector('.kl_reviews__star_rating_widget__label'))) {
              hasKlaviyoChanges = true;
              break;
            }
          }
        }
        if (hasKlaviyoChanges) break;
      }
      
      if (hasKlaviyoChanges) {
        setTimeout(updateReviewCount, 100);
      }
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    
    // Stop observer after 15 seconds
    setTimeout(function() {
      observer.disconnect();
    }, 15000);
  }
  
  // Simple initialization
  function init() {
    updateReviewCount();
    startObserver();
    
    // Single retry after 2 seconds
    setTimeout(function() {
      if (processedCount === 0) {
        updateReviewCount();
      }
    }, 2000);
  }
  
  // Start when ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
})();




// Floating button scroll control
(function() {
  'use strict';
  
  const awp_floatingButton = document.querySelector('.awp_mobile_floating_button');
  
  if (!awp_floatingButton) return;
  
  let awp_isScrolling = false;
  
  function awp_handleScroll() {
    if (awp_isScrolling) return;
    
    awp_isScrolling = true;
    requestAnimationFrame(function() {
      const awp_scrollY = window.pageYOffset || document.documentElement.scrollTop;
      
      if (awp_scrollY > 200) {
        awp_floatingButton.classList.add('awp_show');
      } else {
        awp_floatingButton.classList.remove('awp_show');
      }
      
      awp_isScrolling = false;
    });
  }

  window.addEventListener('scroll', awp_handleScroll, { passive: true });
  
  awp_handleScroll();
})();
































// ==================================================

// Hover video autoplay for product cards
(function() {
  function awp_initHoverVideos() {
    document.querySelectorAll('.card-gallery').forEach(function(awp_gallery) {
      var awp_video = awp_gallery.querySelector('.awp-hover-video');
      if (!awp_video) return;

      awp_gallery.addEventListener('pointerenter', function(e) {
        if (e.pointerType !== 'mouse') return;
        awp_video.play().then(function() {
          awp_video.classList.add('awp-playing');
        }).catch(function() {});
      });

      awp_gallery.addEventListener('pointerleave', function(e) {
        if (e.pointerType !== 'mouse') return;
        awp_video.pause();
        awp_video.currentTime = 0;
        awp_video.classList.remove('awp-playing');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', awp_initHoverVideos);
  } else {
    awp_initHoverVideos();
  }
})();

// ==================================================

// Floating button scroll control
(function() {
  'use strict';

  const awp_floatingButton = document.querySelector('.awp_mobile_floating_button');
  
  if (!awp_floatingButton) return;
  
  let awp_isScrolling = false;
  
  function awp_handleScroll() {
    if (awp_isScrolling) return;
    
    awp_isScrolling = true;
    requestAnimationFrame(function() {
      const awp_scrollY = window.pageYOffset || document.documentElement.scrollTop;
      
      if (awp_scrollY > 200) {
        awp_floatingButton.classList.add('awp_show');
      } else {
        awp_floatingButton.classList.remove('awp_show');
      }
      
      awp_isScrolling = false;
    });
  }

  window.addEventListener('scroll', awp_handleScroll, { passive: true });
  
  awp_handleScroll();
})();